var map = {
	"./five9.png": [
		1772,
		772
	],
	"./msteams.png": [
		6973,
		973
	],
	"./ucce.png": [
		8906,
		906
	],
	"./uccx.png": [
		8039,
		39
	],
	"./unknown.png": [
		8260
	],
	"./wxcalling.png": [
		641,
		641
	],
	"./wxcc.png": [
		7591,
		591
	],
	"./zoomcc.png": [
		5620,
		620
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5483;
module.exports = webpackAsyncContext;